(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var modes = ['light', 'system', 'dark'];
    var root = document.documentElement;

    function syncSliders() {
      var mode = root.getAttribute('data-hor-appearance') || 'system';
      var position = Math.max(0, modes.indexOf(mode));
      document.querySelectorAll('.hor-mode-slider').forEach(function (slider) {
        slider.dataset.position = String(position);
        slider.setAttribute('aria-valuenow', String(position));
        var option = slider.querySelector('[data-mode="' + modes[position] + '"] span');
        slider.setAttribute('aria-valuetext', option.textContent.trim());
        slider.title = slider.getAttribute('aria-label') + ': ' + option.textContent.trim();
      });
    }

    function initializeSliders() {
      document.querySelectorAll('.hor-top-appearance').forEach(function (wrapper) {
        if (wrapper.dataset.initialized) return;
        wrapper.dataset.initialized = 'true';
        var slider = wrapper.querySelector('.hor-mode-slider');
        var control = wrapper.querySelector('[data-hor-appearance-control]');
        var activePointer = null;

        function choose(position) {
          position = Math.max(0, Math.min(2, position));
          var mode = modes[position];
          if (root.getAttribute('data-hor-appearance') === mode) return;
          control.value = mode;
          control.dispatchEvent(new Event('change', { bubbles: true }));
          syncSliders();
        }

        function chooseAt(clientX) {
          var bounds = slider.getBoundingClientRect();
          var relative = (clientX - bounds.left) / bounds.width;
          choose(Math.min(2, Math.max(0, Math.floor(relative * 3))));
        }

        slider.addEventListener('pointerdown', function (event) {
          if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
          activePointer = event.pointerId;
          slider.setPointerCapture(event.pointerId);
          slider.focus({ preventScroll: true });
          chooseAt(event.clientX);
        });
        slider.addEventListener('pointermove', function (event) {
          if (activePointer === event.pointerId) chooseAt(event.clientX);
        });
        slider.addEventListener('pointerup', function (event) {
          if (activePointer !== event.pointerId) return;
          chooseAt(event.clientX);
          activePointer = null;
          if (slider.hasPointerCapture(event.pointerId)) slider.releasePointerCapture(event.pointerId);
        });
        slider.addEventListener('pointercancel', function () {
          activePointer = null;
        });
        slider.addEventListener('lostpointercapture', function () {
          activePointer = null;
        });
        slider.addEventListener('keydown', function (event) {
          var position = Number(slider.dataset.position);
          if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') position -= 1;
          else if (event.key === 'ArrowRight' || event.key === 'ArrowUp') position += 1;
          else if (event.key === 'Home') position = 0;
          else if (event.key === 'End') position = 2;
          else return;
          event.preventDefault();
          choose(position);
        });
        wrapper.hidden = false;
      });
      syncSliders();
    }

    new MutationObserver(syncSliders).observe(root, {
      attributes: true,
      attributeFilter: ['data-hor-appearance']
    });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeSliders);
    } else {
      initializeSliders();
    }
    document.addEventListener('shopify:section:load', initializeSliders);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
